import React from 'react';

const General = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="card mb-4">
          <div className="card-body">
            <h2 className="mb-4">General</h2>

            <form>
              {/* Avatar Upload Section */}
              <div className="row justify-content-between align-items-center mb-4">
                <div className="col">
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <div className="avatar">
                        <img
                          className="avatar-img rounded-circle"
                          src="assets/img/avatars/profiles/avatar-1.jpg"
                          alt="Avatar"
                        />
                      </div>
                    </div>
                    <div className="col ms-n2">
                      <h4 className="mb-1">Your avatar</h4>
                      <small className="text-body-secondary">
                        PNG or JPG no bigger than 1000px wide and tall.
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <button type="button" className="btn btn-sm btn-primary">
                    Upload
                  </button>
                </div>
              </div>

              <hr className="my-5" />

              {/* Personal Info */}
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">First name</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">Last name</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group">
                    <label className="mb-1">Email address</label>
                    <small className="form-text text-body-secondary">
                      This contact will be shown to others publicly, so choose it carefully.
                    </small>
                    <input type="email" className="form-control" />
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">Phone</label>
                    <input
                      type="text"
                      className="form-control mb-3"
                      placeholder="(___)___-____"
                      inputMode="text"
                    />
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">Birthday</label>
                    <input
                      type="text"
                      className="form-control flatpickr-input"
                      readOnly
                    />
                  </div>
                </div>
              </div>

              {/* Save Button */}
              <button type="submit" className="btn btn-primary mt-3">
                Save changes
              </button>

              <hr className="my-5" />

              {/* Switches */}
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="mb-1">Public profile</label>
                    <small className="form-text text-body-secondary">
                      Making your profile public means that anyone on the Dashkit network will be able to find you.
                    </small>

                    <div className="row">
                      <div className="col-auto">
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="switchOne"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="switchOne"
                          ></label>
                        </div>
                      </div>
                      <div className="col ms-n2">
                        <small className="text-body-secondary">
                          You're currently invisible
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="mb-1">Allow for additional Bookings</label>
                    <small className="form-text text-body-secondary">
                      If you are available for hire outside of the current situation, you can encourage others to hire you.
                    </small>

                    <div className="row">
                      <div className="col-auto">
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="switchTwo"
                            defaultChecked
                          />
                          <label
                            className="form-check-label"
                            htmlFor="switchTwo"
                          ></label>
                        </div>
                      </div>
                      <div className="col ms-n2">
                        <small className="text-body-secondary">
                          You're currently available
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr className="mt-4 mb-5" />

              {/* Delete Account */}
              <div className="row justify-content-between">
                <div className="col-12 col-md-6">
                  <h4>Delete your account</h4>
                  <p className="small text-body-secondary mb-md-0">
                    Please note, deleting your account is a permanent action and will not be recoverable once completed.
                  </p>
                </div>
                <div className="col-auto">
                  <button type="button" className="btn btn-danger">
                    Delete
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default General;
